import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ILoaderState } from '../../Entities/entities';
import { LoaderService } from '../../services/loaderService';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass'],
})
export class LoadingComponent implements OnDestroy {
  show = false;
  private subscription: Subscription;

  constructor(private service: LoaderService) {
    this.subscription = this.service.loaderState.subscribe(
      (state: ILoaderState) => {
        setTimeout(() => {
          this.show = state.show;
        });
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
